import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IEnclosedAreaReportViewModel } from 'app/models/mainMenu/mainMenu';
import { BusinessService } from 'app/services/business/business.service';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';

@Component({
  selector: 'app-mainMenu-enclosedAreas',
  templateUrl: './enclosedAreas.component.html',
  styleUrls: ['./enclosedAreas.component.scss']
})

export class EnclosedAreasComponent implements OnInit {
  @Input() countyId: string = '';
  businessEnclosedList: IEnclosedAreaReportViewModel[] = [];

  displayedColumns: string[] = ['businessName', 'businessAddress', 'businessCity', 'businessZip', 'visitDate', 'enclosedAreaDetermination'];
  dataSource = new MatTableDataSource<IEnclosedAreaReportViewModel>(this.businessEnclosedList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public mainMenu: MainMenuService,
    public businessService: BusinessService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    // Business Enclosed
    this.mainMenu.getEnclosedAreas(this.countyId).subscribe({
      next: response => {
        this.mainMenu.businessEnclosedList = response;
        this.dataSource.data = this.mainMenu.businessEnclosedList;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Business Enclosed");
      },
    });
  }

  rowClick(row: any) {
  }

  gotoBusiness(businessId: string) {
    this.businessService.businessId = +businessId;
    this.businessService.businessTab = 4;
    this.sharedService.doRedirect('business/business');
  }

}
